import { Button, Flex, Form, Modal } from "antd";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../../../common/customTitle";
import { t } from "i18next";
import TextArea from "antd/es/input/TextArea";
import { sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { updateServiceProviderAppointmentOrderStatusAction } from "../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import Actions from "../../../../../redux/actions";

const ApproveRejectStatusDialog = ({
  open,
  onClose,
  status,
  currentRecord,
  setCurrentRecord,
}) => {
  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* id dependencies */
  const { selectedStaffIdForUpdateOrderStatus } = useSelector(
    (state) => state.staff
  );
  const { selectedServiceProviderAppointmentId } = useSelector(
    (state) => state.serviceProviderAppointments
  );
  /* id dependencies */

  /* dialog close dependencies */
  const handleDialogClose = () => {
    form.resetFields();
    dispatch(
      Actions.createAction(Actions.SELECTED_STAFF_ID_FOR_UPDATE_ORDER_STATUS, {
        selectedStaffIdForUpdateOrderStatus: "",
      })
    );
    dispatch(
      Actions.createAction(Actions.SELECTED_SERVICE_PROVIDER_APPOINTMENT_ID, {
        selectedServiceProviderAppointmentId: "",
      })
    );
    onClose();
    setCurrentRecord({});
  };
  /* dialog close dependencies */


  /* on submit action */
  const onSubmit = (values) => {
    let dataToBeSent = {
      ...values,
      status: status,
      staff_id:
        status === "approved" ? selectedStaffIdForUpdateOrderStatus : "",
      selectedServiceProviderAppointmentId,
    };

    if (currentRecord?.order_type === "package") {
      dataToBeSent.service_id = currentRecord?.service_id;
    }

    dispatch(updateServiceProviderAppointmentOrderStatusAction(dataToBeSent, setLoading)).then(() => {
      handleDialogClose();
    });
  };
  /* on submit action */

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      destroyOnClose
    >
      <Flex vertical gap="2rem">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {status === "approved" ? "Approve" : "Reject"}
        </CustomTitle>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Form.Item
            label={
              <RequiredLabel
                text={t("Modules.Request.RequestList.note")}
                required={true}
              />
            }
            name="note"
            normalize={(value) => sanitizeDataTypeClientSide(value)}
            rules={[
              {
                required: true,
                message: t("Modules.Request.RequestList.pleaseEnterNote"),
              },
              {
                whitespace: true,
                message: t("Modules.Request.RequestList.pleaseEnterNote"),
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Flex justify="center" align="center">
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              {t("CommonUtils.submit")}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </Modal>
  );
};

export default ApproveRejectStatusDialog;
